<template>
  <section class="department-document student-profile">
    <header class="document-header">
      <h1>STUDENT PROFILE</h1>
      <h2>学生档案</h2>
      <p class="optional-note">All fields are optional 所有字段均为选填</p>
    </header>

    <el-form label-position="top" class="document-form">
      <div class="section-title">Student Information <span>学生信息</span></div>
      <div class="form-grid form-grid-two">
        <el-form-item label="Chinese Name 中文姓名"><el-input v-model="form.chinese_name" :disabled="locked('chinese_name')" /></el-form-item>
        <el-form-item label="American Name (if chosen) 英文名（如有）"><el-input v-model="form.american_name" :disabled="locked('american_name')" /></el-form-item>
        <el-form-item label="First Name 名"><el-input v-model="form.first_name" :disabled="locked('first_name')" /></el-form-item>
        <el-form-item label="Last Name 姓"><el-input v-model="form.last_name" :disabled="locked('last_name')" /></el-form-item>
        <el-form-item label="Email 邮箱"><el-input v-model="form.email" :disabled="locked('email')" /></el-form-item>
        <el-form-item label="WeChat ID 微信号"><el-input v-model="form.wechat_id" :disabled="locked('wechat_id')" /></el-form-item>
        <el-form-item label="Date of Birth 出生日期"><el-date-picker v-model="form.date_of_birth" :disabled="locked('date_of_birth')" type="date" value-format="yyyy-MM-dd" /></el-form-item>
        <el-form-item label="Gender 性别"><el-radio-group v-model="form.gender" :disabled="locked('gender')"><el-radio label="Male 男">Male 男</el-radio><el-radio label="Female 女">Female 女</el-radio></el-radio-group></el-form-item>
        <el-form-item label="Age 年龄"><el-input v-model.number="form.age" :disabled="locked('age')" type="number" min="1" max="99" /></el-form-item>
        <el-form-item label="Grade Entering 入读年级"><el-input v-model="form.grade_entering" :disabled="locked('grade_entering')" placeholder="What grade will you be in when living with your host family?" /></el-form-item>
      </div>

      <div class="section-title">Parent or Agent <span>父母或代理人</span></div>
      <p class="helper-copy">Please list a parent or agent only (no siblings, aunts or uncles).<br />请仅列出父母或代理人（不能是兄弟姐妹、姑姑、叔叔等）。</p>
      <div class="form-grid form-grid-two">
        <el-form-item label="Mother 母亲"><el-input v-model="form.mother_name" :disabled="locked('mother_name')" /></el-form-item>
        <el-form-item label="Father 父亲"><el-input v-model="form.father_name" :disabled="locked('father_name')" /></el-form-item>
        <el-form-item label="Parent or Agent Email 父母或代理人邮箱"><el-input v-model="form.parent_agent_email" :disabled="locked('parent_agent_email')" /></el-form-item>
        <el-form-item label="Parent or Agent WeChat ID 父母或代理人微信"><el-input v-model="form.parent_agent_wechat" :disabled="locked('parent_agent_wechat')" /></el-form-item>
        <el-form-item label="Hometown 家乡"><el-input v-model="form.hometown" :disabled="locked('hometown')" /></el-form-item>
        <el-form-item label="School (You will be attending) 即将入读的学校"><el-input v-model="form.school" :disabled="locked('school')" /></el-form-item>
      </div>

      <div class="section-title">Homestay Preferences <span>住家偏好</span></div>
      <el-form-item label="What is your English level? 英语水平？">
        <el-radio-group v-model="form.english_level" :disabled="locked('english_level')">
          <el-radio label="Beginner 初级">Beginner 初级</el-radio>
          <el-radio label="Intermediate 中级">Intermediate 中级</el-radio>
          <el-radio label="Advanced 高级">Advanced 高级</el-radio>
          <el-radio label="Fluent 流利">Fluent 流利</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Would you like children or siblings in your host family? 是否愿意住家有孩子？">
        <el-radio-group v-model="form.host_children" :disabled="locked('host_children')"><el-radio label="yes">YES 是</el-radio><el-radio label="no">NO 否</el-radio><el-radio label="either">Either 都可以</el-radio></el-radio-group>
      </el-form-item>
      <el-form-item label="Please choose the relationship you hope to have with your host family. 请选择期望的住家相处方式">
        <el-radio-group v-model="form.host_relationship" :disabled="locked('host_relationship')" class="stacked-options">
          <el-radio v-for="option in relationshipOptions" :key="option.value" :label="option.value"><span>{{ option.en }}</span><small>{{ option.zh }}</small></el-radio>
        </el-radio-group>
      </el-form-item>

      <div class="section-title">Health & Lifestyle <span>健康与生活习惯</span></div>
      <div class="form-grid form-grid-two">
        <el-form-item v-for="item in lifestyleItems" :key="item.field" :label="item.label">
          <el-input v-model="form[item.field]" :disabled="locked(item.field)" :placeholder="item.placeholder" />
        </el-form-item>
      </div>

      <div class="section-title">About You <span>关于你</span></div>
      <el-form-item label="What are your favorite hobbies or interests? 你的兴趣爱好？"><el-input v-model="form.hobbies" :disabled="locked('hobbies')" type="textarea" :rows="3" /></el-form-item>
      <el-form-item label="How would you describe your personality? 你的性格特点？"><el-input v-model="form.personality" :disabled="locked('personality')" type="textarea" :rows="3" placeholder="shy, outgoing, friendly, quiet, patient, kind, active..." /></el-form-item>
      <el-form-item label="Please introduce yourself to your host family. 请跟住家介绍你自己。"><el-input v-model="form.introduction" :disabled="locked('introduction')" type="textarea" :rows="6" /></el-form-item>

      <div class="section-title">Personal and Family Photos <span>个人和家庭照片（选填）</span></div>
      <div v-if="form.photos && form.photos.length" class="photo-grid">
        <div v-for="(photo, index) in form.photos" :key="photo.uid || index" class="photo-card">
          <img :src="photo.url || photo" :alt="photo.name || `Photo ${index + 1}`" />
          <el-button v-if="!readonly && !locked('photos')" type="text" @click="removePhoto(index)">删除</el-button>
        </div>
      </div>
      <el-upload
        v-if="!readonly && !locked('photos')"
        action="#"
        accept="image/*"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="addPhoto"
        multiple
      >
        <el-button type="primary" plain :loading="uploadingPhotos > 0">添加照片 Add photos</el-button>
        <div slot="tip" class="el-upload__tip">选择后将直接上传至 OSS；支持 JPG/PNG/WEBP，最多20张，单张不超过10MB。</div>
      </el-upload>
    </el-form>
  </section>
</template>

<script>
import { uploadDepartmentPhoto } from "@/utils/departmentPhotoUpload";

export default {
  name: "StudentProfile",
  props: {
    form: { type: Object, required: true },
    disabledFields: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      uploadingPhotos: 0,
      relationshipOptions: [
        { value: "very_involved", en: "I want to spend a lot of time with my host family doing activities and learning about life in America.", zh: "我想多花时间跟住家一起活动以及了解美国生活。" },
        { value: "balanced", en: "I want to occasionally do activities and have dinner with my host family, while also spending time alone.", zh: "我想偶尔跟住家一起活动和吃晚饭，同时也想有自己独处的时间。" },
        { value: "dinner_only", en: "I plan to spend time with my host family during daily dinner, but not much additional time.", zh: "我想跟住家一起吃晚饭，但不愿意花其他时间跟住家在一起。" },
        { value: "mostly_private", en: "I occasionally want to interact with my host family, but plan to spend most of my time in my room.", zh: "我想偶尔跟住家交流，但是希望大部分时间能自己独处。" },
        { value: "private", en: "I prefer to keep to myself and am not interested in spending time with my host family.", zh: "我不想花时间跟住家一起，更喜欢自己一个人独处。" },
      ],
      lifestyleItems: [
        { field: "smoke", label: "Do you smoke? 你抽烟吗？", placeholder: "Yes / No; please explain if yes" },
        { field: "animal_allergy", label: "Are you allergic to animals? 你对动物过敏吗？", placeholder: "No, or please state the animal" },
        { field: "allergies", label: "Do you have allergies? 你有任何过敏史吗？", placeholder: "No, or please state" },
        { field: "food_restrictions", label: "Do you have food restrictions? 你有食物禁忌吗？", placeholder: "No, or please state" },
        { field: "medical_psychological_conditions", label: "Do you have medical or psychological conditions? 你有健康或者心理问题吗？", placeholder: "No, or please state" },
      ],
    };
  },
  methods: {
    locked(field) {
      return this.readonly || Boolean(this.disabledFields && this.disabledFields[field]);
    },
    async addPhoto(file) {
      if (!file.raw) return;
      if (this.form.photos.length + this.uploadingPhotos >= 20) {
        this.$message.warning("学生照片最多上传20张");
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.warning("单张照片不能超过10MB");
        return;
      }
      if (!file.raw.type.startsWith("image/")) {
        this.$message.warning("请选择图片文件");
        return;
      }
      this.uploadingPhotos += 1;
      this.$emit("photos-uploading", true);
      try {
        const uploadedPhoto = await uploadDepartmentPhoto(file.raw, "family");
        if (!Array.isArray(this.form.photos)) this.$set(this.form, "photos", []);
        this.form.photos.push(uploadedPhoto);
        this.$emit("photos-change", this.form.photos);
        this.$message.success("照片上传成功");
      } catch (error) {
        const message = (error.response && error.response.data && error.response.data.msg) || error.message || "照片上传失败";
        this.$message.error(message);
      } finally {
        this.uploadingPhotos -= 1;
        this.$emit("photos-uploading", this.uploadingPhotos > 0);
      }
    },
    removePhoto(index) {
      this.form.photos.splice(index, 1);
      this.$emit("photos-change", this.form.photos);
    },
  },
};
</script>

<style lang="scss" scoped>
.department-document { color: #172033; }
.document-header { margin-bottom: 32px; padding-top: 28px; text-align: center; }
.document-header h1 { margin: 4px 0; font-size: 30px; letter-spacing: 0.06em; }
.document-header h2 { margin: 0; font-size: 21px; font-weight: 500; }
.optional-note { color: #64748b; }
.section-title { margin: 30px 0 18px; padding-bottom: 10px; border-bottom: 2px solid #dbe7f6; font-size: 18px; font-weight: 700; }
.section-title span { margin-left: 8px; color: #526174; font-weight: 500; }
.form-grid { display: grid; gap: 0 22px; }
.form-grid-two { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.helper-copy { margin: -8px 0 22px; color: #64748b; line-height: 1.7; }
.stacked-options { display: grid; gap: 14px; }
.stacked-options ::v-deep .el-radio { display: flex; align-items: flex-start; height: auto; margin: 0; white-space: normal; }
.stacked-options span { display: block; line-height: 1.55; }
.stacked-options small { display: block; color: #64748b; font-size: 13px; line-height: 1.55; }
.photo-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 16px; margin-bottom: 18px; }
.photo-card { padding: 8px; border: 1px solid #dbe3ed; border-radius: 8px; text-align: center; }
.photo-card img { display: block; width: 100%; height: 150px; border-radius: 5px; object-fit: cover; }
::v-deep .el-date-editor.el-input { width: 100%; }
@media (max-width: 767px) {
  .form-grid-two { grid-template-columns: 1fr; }
  .document-header h1 { font-size: 24px; }
}
@media print {
  .photo-card { break-inside: avoid; }
}
</style>
